<template>
  <div class="multi-scenario-solution">
    <div class="title">多场景解决方案</div>
    <div class="body">
      <div class="body-tab">
        <div v-for="(item, index) in multiScenarioSolutionList" :key="index" :class="item.active" @click="changeTab(index)">
            <span>{{item.text}}</span>
        </div>
      </div>
      <div class="body-content">
        <div v-if="changeIndex == '0'" class="livelihood">
          <div class="livelihood-phone">
            <img src="../image/phone.png" alt="">
          </div>
          <div class="livelihood-text">
            <div class="title">粤省事</div>
            <div class="context">{{contentText1}}</div>
            <div class="livelihood-text-imgdiv">
              <img src="../image/code.png" alt="">
            </div>
            <div class="img-text">扫码体验</div>
          </div>
        </div>
        <div v-if="changeIndex == '1'" class="government-service">
          <div class="government-service-pc">
            <img src="../image/pc.png" alt="">
          </div>
          <div class="government-service-text">
            <div class="title">广东政务服务网</div>
            <div class="context">{{contentText2}}</div>
            <div class="button" @click="JumpUrl()">立即体验</div>
          </div>
        </div>
        <div v-if="changeIndex == '2'" class="synergetic-office">
          <div class="synergetic-office-phone">
            <img src="../image/phone2.png" alt="">
          </div>
          <div class="synergetic-office-text">
            <div class="title">协同办公用户</div>
            <div class="context">{{contentText3}}</div>
          </div>
        </div>
      </div>       
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      multiScenarioSolutionList: [
        {
          text: '指尖民生',
          active: 'active',
        },
        {
          text: '政务服务',
          active: '',
        },
        {
          text: '协同办公',
          active: '',
        },
      ],
      changeIndex: 0,
      contentText1: '“粤省事”是基于政务开放平台开发的首个集成民生服务微信小程序。通过“实人+实名”身份认证核验，无需重复注册，即可通办所有上线民生服务。覆盖279项高频民生服务，打通27张电子证照，打造了数字中国的广东样本。',
      contentText2: '为了让群众在线能办事、在线办完事，原“广东网上办事大厅”现已升级为“广东政务服务网”，将21个地市、121个县区及2万多镇街村居的政务服务纳入，微大家提供更好的服务。',
      contentText3: '全省统一的协同办公平台，利用政务微信的连接能力，打通“部门墙”；提供针对性的协同工具，政务人员可以跨部门、跨地域发起沟通协作、督察督办和内务审批等事务，提升政府行政效率。',
    };
  },
  methods: {
    changeTab (index) {
      for (var i = 0; i < this.multiScenarioSolutionList.length; i++) {
        this.multiScenarioSolutionList[i].active = false;
      }
      this.multiScenarioSolutionList[index].active = 'active';
      this.changeIndex = index;
    },
    JumpUrl () {
      window.location.href = 'http://www.gdzwfw.gov.cn/portal/index';
    },
  },
};
</script>

<style lang="less" src="../styles/multi-scenario-solution.less"></style>
